<template>
  <div class="row modal-buttons">
    <div
      v-for="(button, index) in buttons"
      :key="'modal-button-' + index"
      :class="buttonClass"
    >
      <button
        :class="['button align-center', { secondary: button.secondary }]"
        :disabled="loading"
        @click="clickHandler(button)"
      >
        <span v-html="button.label" />
        <div
          v-show="button.spinner && loading"
          class="spinner spinner-button show-for-large"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ModalButtons',
    props: {
        buttons: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonClass() {
            if (this.buttons.length > 1) {
                return 'small-12 medium-6 columns';
            }

            return 'small-12 medium-12 columns';
        }
    },
    methods: {
        clickHandler(button) {
            if (this.$store !== undefined) {
                return this.$store.dispatch(button.action);
            }

            return button.action();
        }
    }
};
</script>
